import isEqual from 'lodash/isEqual';
import moment from 'moment';
import { Path, PathFilter, PathModel } from '../api/generated';

const normalizeDate = (value: unknown): number | null => {
    if (value === null || value === undefined || value === '') {
        return null;
    }
    const m = moment(value as moment.MomentInput);
    return m.isValid() ? m.valueOf() : null;
};

const normalizeString = (value: unknown): string | null => {
    if (value === null || value === undefined) {
        return null;
    }
    const trimmed = String(value).trim();
    return trimmed.length === 0 ? null : trimmed;
};
const normalizeFilters = (filters: PathFilter[] = []) =>
    filters
        .map((f) => ({ filterId: f.filterId ?? null, filterValues: normalizeString(f.filterValues) }))
        .sort(
            (a, b) =>
                (a.filterId ?? 0) - (b.filterId ?? 0) ||
                String(a.filterValues).localeCompare(String(b.filterValues)),
        );

const normalizeModels = (models: PathModel[] = []) =>
    [...models]
        .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
        .map((m) => m.modelId ?? null);

export const normalizePath = (path: Path) => ({
    name: normalizeString(path.name),
    pathType: normalizeString(path.pathType),
    activeStart: normalizeDate(path.activeStart),
    activeEnd: normalizeDate(path.activeEnd),
    pathFilterModels: normalizeFilters(path.pathFilterModels),
    pathModels: normalizeModels(path.pathModels),
});

export const hasPathChanges = (originalPath: Path, updatedPath: Path): boolean =>
    !isEqual(normalizePath(originalPath), normalizePath(updatedPath));
